// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "(max-width: 768px)";
var _5 = "wrapper-xn-wg";
var _6 = "noInfo-pflgk";
var _7 = "top-zdQmW";
var _8 = "info__wrapper-1TfJz";
var _9 = "amenities-324Ol";
var _a = "image-KXK4a";
var _b = "details-1q96C";
var _c = "details_one-1D-Nq";
var _d = "seatsDetails-1MTa_";
var _e = "segment-2ogK9";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "tabletMiddle", _5 as "wrapper", _6 as "noInfo", _7 as "top", _8 as "info__wrapper", _9 as "amenities", _a as "image", _b as "details", _c as "details_one", _d as "seatsDetails", _e as "segment" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "tabletMiddle": _4, "wrapper": _5, "noInfo": _6, "top": _7, "info__wrapper": _8, "amenities": _9, "image": _a, "details": _b, "details_one": _c, "seatsDetails": _d, "segment": _e }
